import { toJS, autorun } from 'mobx'
import { restaurantCenter, cartMobx, RESTAURANT_EVENT, restaurantConfig } from '..'
import { cloneDeep, keyBy } from '@dt/fe-utils/dist/lodash'

export default function () {
  /**
   * 处理菜单的变化对购物车的影响
   * 当前变化会造成购物车disable （餐品不存在，已售罄，不能被外带）
   * 价格的变化 餐品+加料的价格
   */
  let cartCacheItems: {
    unitPrice: number;
    disabled?: boolean;
    pk: string;
  }[] = []
  restaurantCenter.on(RESTAURANT_EVENT.MENU_APPLY, () => {
    cartCacheItems = cartMobx.viewCartItems.map(viewCartItem => {
      return {
        unitPrice: viewCartItem.unitPrice,
        disabled: viewCartItem.disabled,
        pk: viewCartItem.pk
      }
    })
  })
  restaurantCenter.on(RESTAURANT_EVENT.MENU_END, () => {
    const pkCartItemMap = keyBy(cartCacheItems, 'pk')
    let isPriceChanged = false
    let priceChangedItems: IViewCartItem[] = []
    let isDisabledChanged = false
    let disabledChangedItems: IViewCartItem[] = []
    cartMobx.viewCartItems.forEach(viewCartItem => {
      if (!pkCartItemMap[viewCartItem.pk]) {
        isDisabledChanged = true
        disabledChangedItems.push(cloneDeep(viewCartItem))
        return
      }
      if (viewCartItem.unitPrice !== pkCartItemMap[viewCartItem.pk].unitPrice) {
        isPriceChanged = true
        priceChangedItems.push(cloneDeep(viewCartItem))
      }
      if (viewCartItem.disabled !== pkCartItemMap[viewCartItem.pk].disabled) {
        isDisabledChanged = true
        disabledChangedItems.push(cloneDeep(viewCartItem))
      }
    })
    if (isPriceChanged) {
      restaurantCenter.emit(RESTAURANT_EVENT.CART_ITEMS_PRICE_UPDATE, {
        items: priceChangedItems,
      })
    }
    if (isDisabledChanged) {
      restaurantCenter.emit(RESTAURANT_EVENT.CART_ITEMS_INVALID, {
        items: disabledChangedItems
      })
    }
  })
  setTimeout(() => {
    autorun(() => {
      // HACK 当前在下单后由于先付费会将订单还原到orderMobx.order,使用此变量防止一次计算
      if (cartMobx.info || cartMobx.cartItems) {
        // cartMobx.lastUpdated = Date.now()
        restaurantCenter.emit(RESTAURANT_EVENT.CART_CHANGED, {
          info: toJS(cartMobx.info),
          cartItems: toJS(cartMobx.cartItems)
        })
      }
    })
  })
  // , { delay: 50 }
  restaurantCenter.on(RESTAURANT_EVENT.CART_ITEMS_INVALID, () => {
    if (restaurantConfig.app === 'pos') {
      cartMobx.clearDisabledItems()
    }
  })
}
